import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Import pages
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import ClinicLogin from './pages/ClinicLogin';
import PatientLogin from './pages/PatientLogin';
import AdminDashboard from './pages/AdminDashboard';
import DoctorDashboard from './pages/DoctorDashboard';
import PharmacyDashboard from './pages/PharmacyDashboard';
import LabDashboard from './pages/LabDashboard';
import PatientDashboard from './pages/PatientDashboard';
import ReceptionDashboard from './pages/ReceptionDashboard';
import LabReportPortal from './pages/LabReportPortal';
import BookAppointment from './pages/BookAppointment';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Toaster position="top-right" richColors expand={false} />
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/report/:id" element={<LabReportPortal />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/clinic-login" element={<ClinicLogin />} />
          <Route path="/patient-login" element={<PatientLogin />} />

          {/* Protected routes — each enforces the correct role */}
          <Route path="/admin-dashboard" element={
            <PrivateRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </PrivateRoute>
          } />
          <Route path="/doctor-dashboard" element={
            <PrivateRoute allowedRoles={['doctor']}>
              <DoctorDashboard />
            </PrivateRoute>
          } />
          <Route path="/pharmacy-dashboard" element={
            <PrivateRoute allowedRoles={['pharmacy']}>
              <PharmacyDashboard />
            </PrivateRoute>
          } />
          <Route path="/lab-dashboard" element={
            <PrivateRoute allowedRoles={['lab']}>
              <LabDashboard />
            </PrivateRoute>
          } />
          <Route path="/patient-dashboard" element={
            <PrivateRoute allowedRoles={['patient']}>
              <PatientDashboard />
            </PrivateRoute>
          } />
          <Route path="/reception-dashboard" element={
            <PrivateRoute allowedRoles={['reception']}>
              <ReceptionDashboard />
            </PrivateRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;